import React from 'react';
import { Clock } from 'lucide-react';

function ComingSoon() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      color: 'var(--rmc-ink3)',
      textAlign: 'center',
      padding: '2rem'
    }}>
      <Clock size={64} style={{ marginBottom: '1.5rem', opacity: 0.4 }} />
      <h2 style={{ fontSize: '1.5rem', color: 'var(--rmc-ink2)', marginBottom: '0.75rem', fontWeight: 600 }}>
        Coming Soon
      </h2>
      <p style={{ fontSize: '1rem', maxWidth: '400px', lineHeight: 1.6 }}>
        This module is coming soon. We are working on it and it will be available shortly.
      </p>
    </div>
  );
}

export default ComingSoon;
